import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../../contexts/CartContext';
import { formatPrice } from '../../utils/currency';
import { fromPrice, hasRange, productPath } from '../../utils/products';
import type { Product } from '../../types/product';
import { Stars } from './Stars';
const badgeLabel: Record<string, string> = {
  bestseller: 'Bestseller',
  nieuw: 'Nieuw',
  cadeau: 'Cadeau'
};
export function ProductCard({
  product
}: {
  product: Product;
}) {
  const {
    add
  } = useCart();
  const first = product.variants[0];
  const badge = product.badges[0];
  const to = productPath(product);
  return <article className="group relative flex h-full flex-col" data-id="element-493" data-mp="271gazvmm6xxz">
      <Link to={to} className="relative block overflow-hidden bg-surface" data-id="element-494" data-mp="223o7038p3ldf">
        <img src={product.image} alt={`${product.name} – ${product.subtitle}`} loading="lazy" className="aspect-square w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-495" data-mp="221bptsarhf1f" />
        {product.gallery[1] && <img src={product.gallery[1]} alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-0 transition-opacity duration-300 ease-out group-hover:opacity-100" data-id="element-496" data-mp="3gpvshsoee60j" />}
        {badge && <span className="absolute left-0 top-3 z-10 bg-pink px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.14em] text-white" data-id="element-497" data-mp="3vifrqi8fftcp">
            {badgeLabel[badge]}
          </span>}
      </Link>
      <div className="flex flex-1 flex-col pt-4" data-id="element-498" data-mp="8ac5vci8flug">
        <h3 className="text-sm font-semibold uppercase tracking-[0.1em] text-ink" data-id="element-499" data-mp="db04aj8sj4yp">
          <Link to={to} className="hover:underline hover:underline-offset-4" data-id="element-500" data-mp="ia2x95bhxkqb">{product.name}</Link>
        </h3>
        <p className="mt-1 text-sm font-light text-muted" data-id="element-501" data-mp="2f363h9sj69w0">{product.subtitle}</p>
        <div className="mt-2" data-id="element-502" data-mp="2k1pv9qtt2fwa">
          <Stars rating={product.rating} reviews={product.reviews} data-id="element-503" data-mp="2k2r55rz34wcf" />
        </div>
        <p className="mt-auto pt-3 text-base font-semibold text-ink" data-id="element-504" data-mp="2c0i4bqp77re8">
          {hasRange(product) && <span className="mr-1 text-sm font-normal text-muted" data-id="element-505" data-mp="2726w1kejxoy4">vanaf</span>}
          {formatPrice(fromPrice(product))}
          {first.compareAt && <span className="ml-2 text-sm font-normal text-muted line-through" data-id="element-506" data-mp="2lzzd4gzqylef">{formatPrice(first.compareAt)}</span>}
        </p>
        <button type="button" onClick={() => add(product.slug, first.id)} className="mt-3 h-11 w-full whitespace-nowrap bg-ink text-xs font-semibold uppercase tracking-[0.14em] text-white transition-colors duration-150 hover:bg-berry" aria-label={`${product.name} (${first.label}) toevoegen aan winkelwagen`} data-id="element-507" data-mp="2h27jnijger84">
          In winkelwagen
        </button>
      </div>
    </article>;
}